import { render, staticRenderFns } from "./select-add.vue?vue&type=template&id=0849a64a&"
import script from "./select-add.vue?vue&type=script&lang=ts&"
export * from "./select-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports